import { Flex, Link, Text } from '@optiaxiom/react';

import { UnifiedAgent } from '@frontend/types/agent';

type NameCellProps = {
  agent: UnifiedAgent;
  onClick: (agent: UnifiedAgent) => void;
};

export const NameCell = ({ agent, onClick }: NameCellProps) => {
  return (
    <Flex flexDirection="column" gap="4" alignItems="start">
      <Link cursor="pointer" onClick={() => onClick(agent)} appearance="subtle">
        <Text fontSize="sm" color="fg.accent">
          {agent.name}
        </Text>
      </Link>
      <Text fontSize="sm" color="fg.tertiary">
        @{agent.agent_id}
      </Text>
    </Flex>
  );
};
